<template>
  <mobile-home v-if="$store.state.isMobileHomeVisible" />
  <full-home v-else />
</template>

<script>
const mobileHome = () => import('@/views/mobile-home')
const fullHome = () => import('@/views/full-home')
export default {
  name: 'Home',
  components: {
    mobileHome,
    fullHome
  }
}
</script>

<style scoped>

</style>
